import { useCallback, useEffect, useState } from "react"
import { useAppSelector } from "./redux/hooks"

const useSwapRate = () => {
    const [swapRate, setSwapRate] = useState('')
    const { fromToken, fromChain, toChain, toToken, fromTokenPrice, toTokenPrice } = useAppSelector((state) => state.coreInfo)
    const [ direction, setDirection ] = useState('from')
    
    const switchFromTo = useCallback(() => {
        if(fromToken && toToken) {
            const curFromSymbol = fromToken?.symbol
            const curToSymbol = toToken?.symbol
            if(direction === 'from') {
                setSwapRate(`1 ${curFromSymbol} = ${(+fromTokenPrice / +toTokenPrice).toFixed(4)} ${curToSymbol}`) 
                // if(+fromTokenPrice >= 1) {
                //     setSwapRate(`1 ${curFromSymbol} = ${(+fromTokenPrice / +toTokenPrice).toFixed(4)} ${curToSymbol}`) 
                // } else {
                //     setSwapRate(`1 ${curFromSymbol} = ${(+toTokenPrice *  +fromTokenPrice).toFixed(4)} ${curToSymbol}`) 
                // }
            } else {
                setSwapRate(`1 ${curToSymbol} = ${(+toTokenPrice / +fromTokenPrice).toFixed(4)} ${curFromSymbol}`) 
                // if(+toTokenPrice >= 1) {
                //     setSwapRate(`1 ${curToSymbol} = ${(+toTokenPrice / +fromTokenPrice).toFixed(4)} ${curFromSymbol}`) 
                // } else {
                //     setSwapRate(`1 ${curToSymbol} = ${(+toTokenPrice *  +fromTokenPrice).toFixed(4)} ${curFromSymbol}`) 
                // }
            }
        } else {
            setSwapRate('')
        }
    }, [direction, fromToken, fromTokenPrice, toToken, toTokenPrice])

    useEffect(() => {
        if(fromToken && fromChain && toChain && toToken) {
            if(fromToken?.symbol === toToken?.symbol && fromChain?.nickName !== toChain?.nickName) {
                const curSymbol = fromToken?.symbol
                setSwapRate(`1 ${curSymbol} = 1 ${curSymbol}`)
            } else {
                switchFromTo()
            }
        } else {
            setSwapRate('N/A')
        }
    }, [fromToken, fromChain, toChain, toToken, switchFromTo])

    const chaingeDirection = useCallback(() => {
        if(direction === 'from') {
            setDirection('to')
        } else {
            setDirection('from')
        }
    }, [direction])

    return {swapRate, chaingeDirection}
}

export default useSwapRate